import { addDays } from 'date-fns/addDays';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BulkClosedForArrivalValidation } from 'uplisting-frontend/validations';

export default class BulkClosedForArrivalRepositoryService extends BaseRepositoryService<
  ModelRegistry['bulk-closed-for-arrival']
> {
  recordName = 'bulk-closed-for-arrival';
  implementMethods = ['buildChangeset', 'createRecord'];

  validation = BulkClosedForArrivalValidation;

  get defaultParams() {
    return {
      from: new Date(),
      to: addDays(new Date(), 1),
    };
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/bulk-closed-for-arrival': BulkClosedForArrivalRepositoryService;
  }
}
